module.exports = __webpack_public_path__ + "img/7.81b0d81e.png";